<template>
    <div class="landing-page">
      <ResellerLandingTop id="home" />
      <ResellerFeatures />
  
      <div class="footer-content">
        <h1>Become a operator</h1>
        <p>Gain access to powerful tools and services to grow your content distribution IPTV/OTT business.</p>
        <p>Send email:  operators@streamboxtv.live</p>
      </div>
    </div>
  </template>
  
  <script>
  import ResellerLandingTop from "@/components/ResellerLandingTop.vue";
  import ResellerFeatures from "@/components/ResellerFeatures.vue";
  
  export default {
    name: "HomeView",
    components: {
      ResellerLandingTop,
      ResellerFeatures,
    },
    mounted() {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  };
  </script>
  
  <style scoped>
  .landing-page {
    display: flex;
    flex-direction: column;
  }.footer-content {
  background-color: #000;
  color: #fff;
  text-align: center;
  padding: 60px 20px;
}

.footer-content h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.footer-content p {
  font-size: 1.1rem;
  margin-bottom: 30px;
  color: #ccc;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.reseller-button {
  padding: 12px 30px;
  font-size: 1rem;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(90deg, #00ccff, #0044aa);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
}

.reseller-button:hover {
  filter: brightness(1.2);
}

  </style>
  